import React, {Component} from 'react';
import MaterialIcon from '../../MaterialIcon';
import defaultContextUpdaterOptions from "../components/ContextUpdater/defaultContextUpdaterOptions";
import ContextUpdater from "../components/ContextUpdater/index";
import {connect} from "react-redux";
import {addContextUpdater, setContextUpdaters} from "../../../actions/contextUpdaterActions";
import uniqueId from "lodash/uniqueId";
import {ReactSortable} from "react-sortablejs";
import contextUpdater from "../components/ContextUpdater/index";

class ContextUpdaterTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showList: false,
            contextUpdaters: this.props.contextUpdaters
        };
        this.handleUpdaterSelection = this.handleUpdaterSelection.bind(this);
        this.toggleList = this.toggleList.bind(this);
        this.hideList = this.hideList.bind(this);
        this.updaterList = this.updaterList.bind(this);
    }

    handleUpdaterSelection(event, type, name) {
        event.preventDefault();
        const newContextUpdater = {
            data: defaultContextUpdaterOptions[type],
            type: type,
            name: name
        };
        this.props.addContextUpdater(newContextUpdater);
        this.hideList();
    }

    handleUpdaterAdd() {
        const newContextUpdater = {
            data: {
                contextProperties: [],
                idType: "constantValue",
                idValue: ""
            },
            type: "contextUpdater",
            name: "contextUpdater"
        };
        this.props.addContextUpdater(newContextUpdater);
    }

    toggleList() {
        this.setState({showList: !this.state.showList});
    }

    hideList() {
        this.setState({showList: false});
    }

    updaterList(data) {
        return data.map((contextUpdater, index) =>
            <ContextUpdater key={index}
                            updaterIndex={index}
                            contextUpdater={contextUpdater}
            />
        )
    }

    render() {
        const contextUpdaters = this.props.contextUpdaters;

        return (
            <div className="context-updater-tab">
                <div className="context-updater-line">
                    <div className="add-updater-wrapper">
                        <button className="add-updater" onClick={() => this.handleUpdaterAdd()}>
                            <MaterialIcon icon="add_circle"/>
                            <span>Add Updater</span>
                        </button>
                    </div>
                </div>
                <div onClick={this.hideList}>
                    <ReactSortable key="static"
                                   animation={150}
                                   handle='.drag-handle'
                                   group={'default_group' + uniqueId()}
                                   pull={true} put={true}
                                   list={contextUpdaters}
                                   setList={(newState) => {
                                       if (contextUpdaters.length !== newState.length || !contextUpdaters.every((val, index) => val === newState[index])) {
                                           const newContextUpdaters = [...newState];
                                           newContextUpdaters.forEach((val, key) => {
                                               val.id = key;
                                               return val;
                                           });
                                           this.props.setContextUpdaters(newContextUpdaters);
                                           this.setState({contextUpdaters: newContextUpdaters})
                                       }
                                   }}
                                   className={`list-area group-${contextUpdaters.length ? contextUpdaters?.id : ''}`}
                    >
                        {this.updaterList(this.props.contextUpdaters)}
                    </ReactSortable>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        contextUpdaters: state.contextUpdaters
    }
}

export default connect(mapStateToProps, {addContextUpdater, setContextUpdaters})(ContextUpdaterTab);